import { render, staticRenderFns } from "./NewBookingTemplateSteps.vue?vue&type=template&id=3a6c1f79&"
import script from "./NewBookingTemplateSteps.vue?vue&type=script&lang=js&"
export * from "./NewBookingTemplateSteps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports